import script from "./ExportImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportImage.vue?vue&type=script&lang=ts&setup=true"

import "./ExportImage.vue?vue&type=style&index=0&id=60a953a0&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60a953a0"]])

export default __exports__